import { app } from '../../../../../app';

app.service('ManageSharedPasswordModal', modal);

/** @ngInject */
function modal($uibModal) {
    return account => $uibModal.open({
        component: 'companySharingCenterSharedPasswordsManage',
        resolve: {account: () => account},
    }).result
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/manage/manage-shared-password.modal.js